import { render } from "./product-vendor.vue?vue&type=template&id=cd717e90"
import script from "./product-vendor.vue?vue&type=script&lang=js"
export * from "./product-vendor.vue?vue&type=script&lang=js"

import "./product-vendor.vue?vue&type=style&index=0&id=cd717e90&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__